export function share(element: HTMLElement): void {
  const button = element.querySelector('.button');

  document.addEventListener('click', (e) => {
    if (e.target == button) {
      return
    }

    element.classList.remove('--active');
  });

  button?.addEventListener('click', (e) => {
    e.preventDefault();

    element.classList.toggle('--active');
  })
}